import axios from "axios";
import Swal from "sweetalert2";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

export default function GoogleRegisterAuthButton() {

    const navigate = useNavigate();

    const register = useGoogleLogin({
        flow: "implicit",

        onSuccess: async (tokenResponse) => {

            try {

                // Get Google user profile
                const googleUser = await axios.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    }
                );

                const profileid = "SV" + Math.floor(Math.random() * 999999999);

                const resp = await axios.post(
                    process.env.REACT_APP_API + "/google-register",
                    {
                        name: googleUser.data.name,
                        email: googleUser.data.email,
                        google_id: googleUser.data.sub,
                        picture: googleUser.data.picture,
                        profile_id: profileid,
                    }
                );

                if (resp.data.msgcode === 1) {

                    localStorage.setItem("pid", profileid);

                    Swal.fire({
                        icon: "success",
                        title: "Welcome",
                        text: resp.data.msg,
                        confirmButtonColor: "#900b06",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(() => {
                        navigate("/dashboard");
                    });

                } else {

                    Swal.fire({
                        icon: "error",
                        title: "Google Registration Failed",
                        text: resp.data.msg,
                        confirmButtonColor: "#900b06",
                    });

                }

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: "Google Registration Failed",
                    text:
                        err.response?.data?.msg ||
                        "Unable to register. Please try again.",
                    confirmButtonColor: "#900b06",
                });

            }
        },

        onError: () => {

            Swal.fire({
                icon: "error",
                title: "Cancelled",
                text: "Google Sign-In cancelled.",
                confirmButtonColor: "#900b06",
            });

        },
    });

    return (
        <div className="d-flex justify-content-center mt-3">
            <button
                type="button"
                onClick={() => register()}
                className="btn bg-white border shadow-sm d-flex align-items-center justify-content-center"
                style={{
                    width: "350px",
                    height: "44px",
                    borderRadius: "22px",
                    fontWeight: "500",
                    color: "#3c4043",
                    border: "1px solid #dadce0",
                }}
            >
                <img
                    src="https://developers.google.com/identity/images/g-logo.png"
                    alt="Google"
                    width="20"
                    height="20"
                    className="me-2"
                />
                Register with Google
            </button>
        </div>
    );
}